/* eslint-disable prefer-promise-reject-errors */
import { scope, sendCodeTimeKey } from '@/config/base';
import { getLocalStorage, removeLocalStorage, removeToken, setLocalStorage } from '@/utils/cookies';
import { MailOutlined, MobileOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import { doLogin, sendPhoneCode } from '../../http';
import { validIsMobile } from '../../utils';
import SubmitButton from '../SubmitButton';
import styles from './index.less';

const { useForm } = Form;
const sendCodeTimeOut = 60;

type SmsLoginProps = {
  /** 白色背景 */
  white?: boolean;
  /** 下一步 */
  onNext?: (token: string) => void;
  /** 返回登录回调 */
  backLogin?: () => void; // 返回登录
};

/** 忘记密码 - 校验手机号码 */
const AuthMobile: React.FC<SmsLoginProps> = (props) => {
  const { white, onNext, backLogin } = props;
  const [form] = useForm();

  const [phoneNo, setPhoneNo] = useState('');
  const [canSendCode, setCanSendCode] = useState(true);
  const [canLogin, setCanLogin] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [timer, setTimer] = useState<any>(null);

  const onFinish = async (values: any) => {
    console.log('Success:', values);
    setCanLogin(true);
    httpDoLoginReq({ channel: 'phone', scope, resetPwd: true, ...values });
  };

  /** 登录 */
  const httpDoLoginReq = async (params: any) => {
    try {
      const token: any = await doLogin(params);
      setCanSendCode(true);
      onNext && onNext(token);
    } catch (err) {
      removeToken();
      console.log(err);
      setCanSendCode(true);
      clearTimeout(timer);
      removeLocalStorage(sendCodeTimeKey);
    }
  };

  const validPhoneNo = (rule: any, value: any) => {
    if (value === '') {
      return Promise.reject('手机号码不能为空');
    }
    if (!validIsMobile(value)) {
      return Promise.reject('手机号格式不正确');
    }
    return Promise.resolve();
  };

  const getErrorMessage = () => {
    const errors = form.getFieldsError();
    let errorMessage: string[] = [];
    errors.forEach((item) => {
      errorMessage = errorMessage.concat(item.errors);
    });
    const errorMsg = errorMessage.reverse().pop();
    errorMsg && message.error(errorMsg);
  };

  const handleSendSmsCode = async () => {
    if (!phoneNo) {
      message.error('手机号码不能为空');
      return;
    }
    try {
      await sendPhoneCode(phoneNo, true);
      setLocalStorage(sendCodeTimeKey, Date.now());
      setTimeLeft(sendCodeTimeOut);
      setCanSendCode(false);
    } catch (err) {
      setCanSendCode(true);
      clearTimeout(timer);
      removeLocalStorage(sendCodeTimeKey);
    } finally {
      console.log(1);
    }
  };

  useEffect(() => {
    const time = getLocalStorage(sendCodeTimeKey);
    if (time) {
      const timeLeftData = Math.floor((Date.now() - time) / 1000);
      const isCan = timeLeftData > sendCodeTimeOut;
      setCanSendCode(isCan);
      if (!isCan) {
        setTimeLeft(sendCodeTimeOut - timeLeftData);
      }
    }
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      setCanSendCode(false);
      const time = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 900);
      setTimer(time);
    } else {
      setCanSendCode(true);
    }
  }, [timeLeft]);

  return (
    <Form
      name="basic"
      form={form}
      style={{ width: 312 }}
      size="large"
      onFinish={onFinish}
      onFinishFailed={getErrorMessage}
      autoComplete="off"
    >
      <Form.Item name="phone" noStyle rules={[{ validator: validPhoneNo }]}>
        <Input
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          autoComplete="new-password"
          maxLength={11}
          placeholder="输入手机号"
          prefix={<MobileOutlined />}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
      </Form.Item>

      <Form.Item name="captcha" noStyle rules={[{ required: true, message: '验证码不能为空' }]}>
        <Input
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          prefix={<MailOutlined style={{ fontSize: 14 }} />}
          suffix={
            <Button
              type="link"
              size="small"
              style={{ fontSize: 16 }}
              disabled={!canSendCode || !validIsMobile(phoneNo)}
              onClick={() => handleSendSmsCode()}
            >
              {canSendCode ? '获取验证码' : `${timeLeft}s后重新获取`}
            </Button>
          }
          placeholder="输入短信验证码"
          autoComplete="off"
        />
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }} style={{ marginTop: 168 }}>
        {/* <Button
          className={`${styles['custom-btn']} ${!canLogin ? styles.disabled : ''}`}
          type="primary"
          htmlType="submit"
          size="large"
          block
        >
          下一步
        </Button> */}
        <SubmitButton
          form={form}
          label="下一步"
          className={styles['custom-btn']}
          buttonProps={{ type: 'primary', size: 'large', block: true }}
        />
        <Button className={`${styles['back-btn']}`} size="large" block onClick={backLogin}>
          返回登录
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AuthMobile;
